<div class="simple-panel mat-elevation-z3 mat-body-1" [ngClass]="color">
  <ng-content></ng-content>
</div>
